import { useRef } from 'react'
import { MdArrowBack } from 'react-icons/md'

import type { RowClickedEvent } from 'ag-grid-community'
import type { ReactElement } from 'react'
import type { ITemplate, ITemplateParams } from '~/types/template'

import columns from './columns'

import Label from '~/components/Label'
import { ModalBody } from '~/components/Modal/Layout'
import TableWrapper from '~/components/Tables/TableWrapper'

interface Props {
  isLoading: boolean
  onBackClick: VoidFunction
  onTemplateClick: (params: ITemplateParams) => void
  selectedTemplateKey?: string
  templates: ITemplate[]
}

const TemplateVersionSelector = ({
  onBackClick,
  onTemplateClick,
  selectedTemplateKey,
  templates,
}: Props): ReactElement => {
  /** Local state */

  const tableRef = useRef<HTMLDivElement>(null)

  const templateVersionOptions = templates
    ?.filter(({ template_key }) => template_key === selectedTemplateKey)
    .map(({ capabilities, device_type, is_unity, navigation_target_outputs, status, template_key, type, version }) => ({
      capabilities,
      deviceType: device_type,
      isUnity: is_unity,
      key: template_key,
      navigationTargetOutputs: navigation_target_outputs,
      status,
      type,
      version,
    }))

  /** Handlers */

  const handleRowClicked = (evt: RowClickedEvent) => {
    const { deviceType, isUnity, key, version } = evt.data

    selectedTemplateKey &&
      onTemplateClick({
        deviceType: deviceType,
        isUnity: isUnity,
        key: key,
        version: version,
      })
  }

  return (
    <ModalBody>
      <div className="template-selector-modal-container">
        <div className="back-navigation-container" onClick={onBackClick}>
          <MdArrowBack size={18} />
          <Label label="Back to templates" />
        </div>
        <div className="template-selector-modal-content">
          <div className="table-wrapper">
            <TableWrapper
              columnDefs={columns}
              entriesName="template-versions"
              onRowClicked={handleRowClicked}
              rowData={templateVersionOptions}
              tableRef={tableRef}
              withPagination={false}
            />
          </div>
        </div>
      </div>
    </ModalBody>
  )
}

export default TemplateVersionSelector
